// extracted by mini-css-extract-plugin
export var hideEditor = "_lj-2";
export var infoIcon = "_lj-3";
export var label = "_lj-1";
export var labelContainer = "_lj-0";
export var readonlyText = "_lj-4";